import axios from 'axios'

export default {
    namespaced: true,
    state: {
    },
    getters: {
    },
    mutations: {
    },
    actions: {
        fetch({dispatch}, payload) {
            return new Promise((resolve, reject) => {
                axios.post(
                    '/api/mixins/dishes/list', payload
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                    reject(error)
                })
            })
        },
        add({dispatch, rootState}, data) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/dishes/add',
                    prepareData(data, rootState)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        edit({dispatch, rootState}, editedItem) {
            return new Promise((resolve) => {
                axios.post(
                    '/api/mixins/dishes/edit/' + editedItem.id,
                    prepareData(editedItem, rootState)
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, {root: true})
                })
            })
        },
        delete({dispatch}, itemId) {
            return new Promise((resolve) => {
                axios.delete(
                    '/api/mixins/dishes/dell/' + itemId
                ).then(({data}) => {
                    resolve(data.data)
                }).catch((error) => {
                    dispatch('checkUnauthenticated', error, { root: true })
                })
            })
        },
        copy(dispatch, data) {
            return axios.post(
                '/api/menu-manager/dishes/copy', data
            ).catch((error) => {
                dispatch('checkUnauthenticated', error, { root: true })
            })
        }
    }
}

function prepareData (data, rootState) {
    const fd = new FormData()
    if (data.image) {
        fd.append('image', data.image)
    }
    fd.append('name', data.name)
    fd.append('composition', data.composition)
    fd.append('published', Number(data.published))
    fd.append('price', data.price)
    fd.append('weight', data.weight)
    fd.append('time_preparing', data.time_preparing)
    fd.append('category_id', data.category_id)
    fd.append('hotel_id', String(rootState.auth.currentHotel.id))

    return fd
}
